import React from 'react';
import { NavLink } from 'react-router-dom';

class AboutCompany extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 bg-white">
                    <div className="container">
                        <div className="section-content ">
                            <div className="m-service-containt text-black">
                                <div className="row">
                                    <div className="col-md-5 col-sm-12">
                                        <div className="service-about-left">
                                            <div className="mt-media">
                                                <img src={require('./../../images/s-1.png')} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-sm-12">
                                        <div className="service-about-right m-b30">
                                            <h3 className="m-t0">Building foundations for progress with disciplined delivery and dependable execution.</h3>
                                            <p>Buildco Associates provides complete construction, interior fit-out, refurbishment, and structured networking services for commercial, banking, and institutional environments. Our team manages planning, coordination, quality control, and handover so clients receive a clean process and a finished space that performs from day one.</p>
                                            <p>We work closely with demanding projects where timelines, safety, and presentation matter, supporting clients who require a single, professionally managed partner for both building works and technical infrastructure.</p>
                                            <div className="call-for-quote-outer">
                                                <div className="call-quote">
                                                    <span>Call For a Quote:</span>
                                                    <h4>(+923) 335-196-170</h4>
                                                </div>
                                                <div className="call-estimate bg-dark">
                                                    <NavLink to={"/contactus"} className="site-button-secondry btn-effect">Request a Consultation</NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default AboutCompany;